'use strict';
var populationElements = document.querySelectorAll('.population');
var populations = Array.from(populationElements).map(function(element) {
    return Number(element.textContent.replace(/,/g, ''));
});
var total = populations.reduce(function(sum, population) {
    return sum + population;
}, 0);
var average = Math.round(total / populations.length);
document.querySelector('.total-population').textContent = total.toLocaleString();
document.querySelector('.average-population').textContent = average.toLocaleString();

//# sourceMappingURL=js_get_data_DOM.2b0d67ca.js.map
